import gql from "graphql-tag";

export default gql`
{
  yearStatData {
    year
    amount
  }
}`;